<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">
					<div class="user_ti">个人中心</div>
					<div class="user_menu">
						<div class="item" @click="open(item)" :class="{'active':menu_id == item.id}"
							v-for="(item, index) in menu">
							{{item.name}}
						</div>

					</div>
				</div>
				<div class="fr" v-if="info && info.cmsarchives">

					<div class="user_center">

						<div class="user_de_ti" style="margin-bottom: 30px;">订单详情</div>






						<div class="user_page_list details-box">

							<div class="order-box">
								<div class="el-image cover"><img :src="info.cmsarchives.image" class="el-image__inner">
								</div>
								<div class="order-title">
									<div class="title ellipsis-2"><span>
											{{info.cmsarchives.title}}
										</span></div>

								</div>
								<div class="status tr">


									<span class="text CANCEL" v-if="info.status == '2'">已取消</span>
									<span class="text BUYER_AGREE" v-if="info.status == '0'">待付款</span>
									<span class="text AGREE" v-if="info.status == '1'">待取号</span>
									<span class="text AGREE" v-if="info.status == '3'">已完成</span>
									<div class="price mt-30" style="border-bottom: none;">
										<span>
											￥
											<span>{{info.price}}</span></span>
									</div>
								</div>
								<div class="orderDtl_botton">
									<div class="orderDtl_botton_cancel" @click="cancel" v-if="info.status == '0'">
										取消订单
									</div>
									<div class="orderDtl_botton_commit" @click="payOrder" v-if="info.status == '0'">
										立即支付
									</div>
									<div class="orderDtl_botton_commit" @click="lianxi"
										v-if="info.status == '1' || info.status == '3'">
										联系客服
									</div>

								</div>
							</div>



							<div class="newOrder_tips">
								<p style="padding-bottom: 10px;color: red;"
									v-if="info.status == '1' || info.status == '3'">提号客服若长时间未回复请联系：13540034003微信同号</p>
							</div>

							<div class="compensation_box" v-if="info.baopei != '0'">
								<div class="title-big flex-a" style="background: transparent; color: rgb(51, 51, 51);">
									<div class="title-box">
										<div class="pillar" style="padding-left: 20px;">已加购包赔服务</div>
									</div>
									<div class="right"></div>
								</div>
								<div class="indemnity_box" v-if="info.baopei == '1'">
									<div>
										<div class="indemnity_box_title">
											<h4>找回包赔</h4>
											<div>
												<p>
													最高赔付
													<span class="colorRed">100% </span>
												</p> <img @click="visible = true"
													:src="require(`@/assets/image/indemnity_box_tip.png`)">
											</div>
										</div>
										<div class="indemnity_box_content">
											<div class="indemnity_box_content_introduction" v-if="info.shouxufei == 0">
												0手续费，账号若发生找回，7个工作日未追回可申请全额赔付</div>

											<div class="indemnity_box_content_introduction" v-if="info.shouxufei > 0">
												5%手续费，账号若发生找回，7个工作日未追回可申请全额赔付
											</div>
											<div class="indemnity_box_footer">
												<div>￥{{info.shouxufei}}</div>
											</div>
										</div>
									</div>
								</div>
								<div class="indemnity_box" v-if="info.baopei == '2'">
									<div>
										<div class="indemnity_box_title">
											<h4>充值包赔</h4>
											<div>
												<p>
													最高赔付
													<span class="colorRed">300% </span>
												</p> <img @click="visible = true"
													:src="require(`@/assets/image/indemnity_box_tip.png`)">
											</div>
										</div>
										<div class="indemnity_box_content">
											<div class="indemnity_box_content_introduction">
												10%手续费，账号若发生找回，7个工作日未追回可申请最高300%赔付</div>
											<div class="indemnity_box_footer">
												<div>￥{{info.shouxufei}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>


							<div class="order-info" v-if="info.status == '3'">
								<div class="flex">
									<div class="order-info-fl" style="width: 100%;">
										<div class="title-big flex-a"
											style="background: transparent; color: rgb(51, 51, 51);">
											<div class="title-box">
												<div class="pillar" style="padding-left: 20px;">账号信息
												</div>
											</div>
											<div class="right"></div>
										</div>
										<div class="infos">
											<div class="column text-565"><span>账号：</span>
												<span>{{info.acc}}</span>
											</div>
											<div class="column text-565"><span>密码：</span>
												<span>{{info.pass}}</span>
											</div>



										</div>

									</div>

								</div>
							</div>


							<div class="order-info">
								<div class="flex">
									<div class="order-info-fl" style="width: 100%;">
										<div class="title-big flex-a"
											style="background: transparent; color: rgb(51, 51, 51);">
											<div class="title-box">
												<div class="pillar" style="padding-left: 20px;">订单信息
												</div>
											</div>
											<div class="right"></div>
										</div>
										<div class="infos">
											<div class="column text-565"><span>订单编号：</span>
												<span>{{info.order_no}}</span>
											</div>
											<div class="column text-565"><span>创建时间：</span>
												<span>{{info.createtime}}</span>
											</div>

											<div class="column text-565" v-if="info.baopei == '1'"><span>是否包赔：</span>
												<span>找回包赔</span>
											</div>
											<div class="column text-565" v-if="info.baopei == '2'"><span>是否包赔：</span>
												<span>充值包赔</span>
											</div>

											<div class="column text-565" v-if="info.status == '1'"><span>支付时间：</span>
												<span>{{info.paytime}}</span>
											</div>

										</div>
										<div class="infos ">
											<div class="column text-565"><span>号价：</span> <span
													class="colF7423f">￥{{info.haojia}}</span></div>
											<div class="column text-565" v-if="info.baopei != '0'"><span>包赔手续费：</span>
												<span class="colF7423f">￥{{info.shouxufei}}</span>
											</div>
											<div class="column text-565"><span>总价：</span> <span
													class="colF7423f">￥{{info.price}}</span></div>
										</div>
									</div>

								</div>
							</div>







						</div>

					</div>



				</div>
			</div>
		</div>
		<el-dialog :visible.sync="visible" :center="true" custom-class="dialogColor2" title="包赔服务" width="800px"
			destroy-on-close @closed="visible = false">
			<div class="compensationModel_box">
				<div>
					<div class="compensationModel_box_title">

						<img :src="require(`@/assets/image/baopei_icon.png`)" alt="">

						<span>包赔规则</span>
					</div>
					<div>
						<p>账号发生恶意找回需在七个工作日内必须联系售后处理</p>
						<p>超过七个工作日再联系平台，包赔无效</p>
						<p>(安全中心技术部门反馈申诉记录只保留七个工作日）</p>
						<p>红六游戏在七个工作日以内未能成功帮助买家追回账号进行赔付</p>
					</div>
				</div>
				<div>
					<div class="compensationModel_box_title">





						<img :src="require(`@/assets/image/zhuyi_icon.png`)" alt=""> <span>注意事项</span>
					</div>
					<div>
						<p>若私下更换密保手机或脱离平台交易，包赔将无效</p>
					</div>
				</div>
			</div>
		</el-dialog>


		<el-dialog :visible.sync="payvisible" :center="true" custom-class="pay_dialog" title="收银台" width="544px"
			destroy-on-close @closed="payvisible = false">
			<div class="pay_dialog_page">
				<div class="scan_operat">
					<div class="scan_area">
						<p class="scan_area_title">请打开支付宝扫一扫</p>
						<div class="qr-box">
							<div ref="qrcode" id="qrcodePay" style="display: inline-block;">


							</div>

						</div>
						<p class="pay_risk" style="display: none;">订单已超时取消，请重新下单</p>
						<div class="pay_risk">
							<el-statistic format="mm:ss" :value="pay_info.expiretime*1000" time-indices title="">
							</el-statistic>
							后二维码失效
						</div>
					</div>
					<div class="scan_control">
						<p class="scan_control_price">
							应付金额：
							<span>¥{{pay_info.price}}</span>
						</p>
						<div class="scan_control_option">
							<div>

								<img :src="require(`@/assets/image/alipay.png`)" alt="ALIPAY">
								<span>支付宝</span>
							</div> <img :src="require(`@/assets/image/radio_icon_active.png`)" alt="选择支付方式"
								class="option_single_choice">

						</div>

						<p class="scan_control_tips">为确保您当前交易的安全，扫描二维码后会进行安全验证！</p>
					</div>
				</div>
				<div class="pay_miaoshu">
					<div class="p1"> 如果付款失败，请添加以下支付宝账户好友转账</div>
					<div class="p2">
						<p>15620077874 <span>王炯</span></p>
						<p>13691450291 <span>王炯</span></p>
						<p>1216343799@qq.com <span>王雪竹</span></p>
						<p>17365552126 <span> 四川中霄（王兴权）</span></p>
					</div>
					<div class="p3">
						<a class="lianxi_kefu" @click="openKefu">我已付款，点我提号
						</a>
					</div>
				</div>
			</div>
		</el-dialog>





	</div>

</template>


<script>
	import QRCode from 'qrcodejs2';
	import {
		Notification,
		Message
	} from 'element-ui'
	import moment from 'moment';
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 2,
				title: "",
				info: {},
				menu_id: 0,
				menu: [{
						id: 1,
						name: "主页",
						url: "/user"
					},
					{
						id: 2,
						name: "我的收藏",
						url: "/shoucang"
					},
					// {
					// 	id: 3,
					// 	name: "我发布的账号",
					// },
					{
						id: 6,
						name: "我的订单",
						url: "/order"
					},
					{
						id: 4,
						name: "修改密码",
						url: "/editpass"
					},
					{
						id: 5,
						name: "注销",
					}
				],
				visible: false,
				payvisible: false,
				pay_info: {}

			}
		},
		computed: {
			userinfo() {
				return this.$store.getters.userinfo
			}
		},
		created: function(data) {
			this.order_id = this.$route.query.id

			if (this.order_id == undefined) {
				this.order_id = this.$route.params.id
			}

			console.log(111)
			this.getDetail()
			// this.getDetail();


		},
		watch: {
			$route() {

			}
		},
		methods: {
			openKefu() {
				api_kefu.push('cmd', 'kfclient');
				api_kefu.push('type', 'new');
				api_kefu.query();
			},
			lianxi() {
				window.open('https://tb.53kf.com/code/client/696ac86f721b23bfe7eb4b6e24f45b349/1')
			},
			open(item) {
				if (item.id == 5) {
					localStorage.removeItem('usertoken')
					sessionStorage.removeItem('usertoken')
					localStorage.setItem('path', this.$route.path)
					this.$router.push("/")
				} else {

					this.$router.push(item.url)
				}
			},

			payOrder() {
				var that = this;
				this.rq.requests.post("api/index/payOrder", {
					id: that.order_id,
				}).then(res => {
					if (res.code == 1) {
						that.payvisible = true
						that.pay_info = res.data

						setTimeout(function() {
							new QRCode(document.getElementById("qrcodePay"), {
								text: that.pay_info.pay.qr_code,
								width: 130,
								height: 130
							});

						}, 500);
					}
				}).catch(error => {

				})
			},

			cancel() {
				var that = this;
				this.rq.requests.post("api/order/cancel", {
					id: that.order_id,
				}).then(res => {
					if (res.code == 1) {
						Message.success({
							message: "取消成功",
							duration: 3000
						})
						location.reload()
					} else {
						Message.error({
							message: res.msg,
							duration: 3000,
						})
					}


				}).catch(error => {

				})
			},
			getDetail(id) {
				var that = this;
				this.rq.requests.post("api/order/detail", {
					id: that.order_id,
				}).then(res => {

					that.info = res.data;

				}).catch(error => {

				})
			},






		}


	}
</script>
<style>
	.indemnity_box {
		padding: 0 0 !important;
	}
</style>